import React, { Component } from 'react';
import { translate } from "react-i18next";
import ReadAxios from '../axiosComponent/read';
import ReadVAxios from '../axiosComponent/readV';
import UpdateAxios from '../axiosComponent/update';
import DeleteAxios from '../axiosComponent/delete';
import ReadMasterAxios from '../axiosComponent/readMaster'
import { isEmpty } from 'lodash';
import { Form as FormUi, Container, Dropdown, Grid, Checkbox, Radio, Table, Button } from "semantic-ui-react";
import MultiSelect from "react-multi-select-component";
import PopupModal from '../common/popupModal';
import Rselect from 'react-select';
import {
    successAlertDispatcher,
    errorAlertDispatcher,
  } from "../../redux/actions/alertAction";
  import { connect } from "react-redux";

class UserBranch extends Component {
    constructor(props) {
        super(props);
        this.state = {
        userInfo: [],
        permissions: '',
        openViewModal: false,
        selected: [],
        billsPartySelected: [],
        billsPartyBranchSelected: [],
        branches: [],
        billing_party: [],
        mapping_user_branch: [],
        mapping_billing_branch: [],
        billing_party_data: [],
        show: false
    }
    }

    componentDidMount () {
        this.getBranch()
        this.getBranchBillingData()
        this.getBillPartyData()
    }

    handleModelOpen = () => {
        this.setState({ openViewModal: true});
    };

    handleBillingSelect = (data, e) => {
    this.getBillingParty(data.value)
    }

    getBillingParty = (id) => {
        let userinfoId = localStorage.getItem('userInfoId')
        // GetCommonBaseURL({
        //     newUrl: `masters/billing_party_branch`,
        //     mainUserId: +userinfoId,
        //     billingPartyId: id,
        //     response: ((data) => {
        //         this.setState({
        //             billing_party: data.data.resultSet
        //         })
        //     })
        // })
    }

    getBranch = () => {
        ReadAxios({ url: `branch`,  }).then((response) => {
            console.log(response);
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            // this.props.successAlertDispatcher(alert)
            this.setState({
                branches: response.data.resultSet,
            })
        }).catch((error) => console.log(error))
    }

    handleSelect = (data) => {
        this.setState({ selected: data })
    }

    handleUserLinkBranch = () => {
        this.state.selected.map((object, index) => {
            UpdateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/user_branch`, payload: { branchId: object.value, mainUserId: this.props.userInfo.u_id} }).then((response) => {
                console.log(response);
                let alert = {
                    type: "success",
                    messageHeader: "Success",
                    messageBody: response.data.message,
                };
                this.props.successAlertDispatcher(alert)
                this.getBranchBillingData()
            }).catch((error) => console.log(error))
        })
    }

    handleBillingPartyBranch = (data) => {
        this.setState({ billsPartyBranchSelected: data })
    }

    getBranchBillingData = () => {
        console.log('main', this.props.userInfo.u_id);
        ReadMasterAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/user_billing_party_branch`, mainUserId: this.props.userInfo.u_id }).then((response) => {
            console.log('getBranchBillingData',response.data);
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            // this.props.successAlertDispatcher(alert)
            this.setState({
                mapping_billing_branch: response.data.resultSet,
            })
        }).catch((error) => console.log(error))
        ReadMasterAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/user_branch`, mainUserId: this.props.userInfo.u_id }).then((response) => {
            let info = []
            response.data.resultSet.map((o, i) => {
                let temp = {}
                temp.label = o.branchName
                temp.value = o.branchId
                temp.disabled = true
                info[i] = temp
            })
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            // this.props.successAlertDispatcher(alert)
            this.setState({
                mapping_user_branch: response.data.resultSet,
                selected: info
            })
        }).catch((error) => console.log(error))
    }

    getBillPartyData = () => {
        ReadMasterAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party` }).then((response) => {
            console.log('getBranchBillingData',response.data);
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            // this.props.successAlertDispatcher(alert)
            this.setState({
                billing_party_data: response.data.resultSet
            })
        }).catch((error) => console.log(error))
    }

    branchDelete = (e) => {
        let id = e.currentTarget.dataset.id
        DeleteAxios({ url: `mappings/user_branch`, uniqueId: id }).then((response) => {
            console.log('getBranchBillingData',response.data);
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            this.props.successAlertDispatcher(alert)
            if (response.status === 200) {
                // NotificationManager.success(data.message, 'Delete');
                this.getBranchBillingData()
            }
        }).catch((error) => console.log(error))
    }

    branchBillingDelete = (e, data) => {
        let id = e.currentTarget.dataset.id
        DeleteAxios({ url: `mappings/user_billing_party_branch`, uniqueId: id }).then((response) => {
            console.log('getBranchBillingData',response.data);
            let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: response.data.message,
            };
            this.props.successAlertDispatcher(alert)
            if (response.status === 200) {
                // NotificationManager.success(data.message, 'Delete');
                this.getBranchBillingData()
            }
        }).catch((error) => console.log(error))
    }

    handleCloseModal = (data) => {
            this.setState({ openViewModal: false }) 
        this.getBranchBillingData()
        
        
    }

    render() {
        const { userInfo, openViewModal, mapping_billing_branch, mapping_user_branch, subcribedAlerts } = this.state
        let options = []
        if (this.state.branches.length > 0) {
            console.log('check');
            this.state.branches.map((object, index) => {
                let temp = {}
                temp.label = object.branchName
                temp.value = object.branchId
                options[index] = temp
            })
        }
        let optionsBilling = []
        if (this.state.billing_party_data.length > 0) {
            this.state.billing_party_data.map((object, index) => {
                let temp = {}
                temp.label = object.billingPartyName
                temp.value = object.billingPartyId
                optionsBilling[index] = temp
            })
        }
        let optionsBillingPartyBranch = []
        if (this.state.billing_party.length > 0) {
            this.state.billing_party.map((object, index) => {
                let temp = {}
                temp.label = object.billingPartyBranchName
                temp.value = object.billingPartyBranchId
                optionsBillingPartyBranch[index] = temp
            })
        }

        let divideArray = Math.ceil(mapping_user_branch.length / 2)
        let arrayPart1 = mapping_user_branch.slice(0, divideArray);
        let arrayPart2 = mapping_user_branch.slice(divideArray)
        return (
            <>
            <div className="container-fluid animated slideInDown pad w3-white" style={{zIndex: "1"}}>
                <Grid>
                    <Grid.Row columns="1" className=" ml-2 w3-small">
                    <Grid.Column width={10}>
                            <label className="font-weight-bold mt-1">{this.props.t("branch.link_user_branch") || "Link User Branch"}</label>
                        </Grid.Column>
                        <Grid.Column width={6}>
                        <div className="d-flex float-right">
                        <MultiSelect
                        options={options}
                        className="p-mselect"
                        value={this.state.selected}
                        defaultValue="branch"
                        onChange={this.handleSelect}
                        labelledBy={"Select"} />
                        <Button className="w3-button w3-blue w3-hover-red w3-round w3-small" type="button" onClick={this.handleUserLinkBranch}>{this.props.t("branch.add") || "Add"}</Button>
                        </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="1" className=" ml-2 w3-small">
                    <Grid.Column width={8}>
                    <Table hover>
                        <thead>
                            <tr className="w3-light-grey">
                                <th>{this.props.t("branch.branch_name") || "Branch Name"}</th>
                                <th className="text-right">{this.props.t("branch.delete") || "Delete"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {arrayPart1.length > 0 ?
                                arrayPart1.map((object, idx) => (
                                    <tr key={idx}>
                                        <td>{object.branchName}</td>
                                        <td className="text-right">
                                            {console.log(object)}
                                            <Button basic size="mini" type="button" icon onClick={this.branchDelete} data-id={object.userBranchMapId}
                                                variant="outline-danger">
                                                <i className="fa fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                                : (<>{this.props.t("branch.message") || 'No Records Found'}</>)}

                        </tbody>
                    </Table>
                    </Grid.Column>
                    <Grid.Column width={8}>
                    <Table hover>
                        <thead>
                            <tr className="w3-light-grey">
                                <th>{this.props.t("branch.branch_name") || "Branch Name"}</th>
                                <th className="text-right" >{this.props.t("branch.delete") || "Delete"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {arrayPart2.length > 0 ?
                                arrayPart2.map((object, idx) => (
                                    <tr key={idx}>
                                        <td>{object.branchName}</td>
                                        <td className="text-right">
                                            <Button basic size="mini" type="button" icon onClick={this.branchDelete} data-id={object.userBranchMapId}
                                                variant="outline-danger">
                                                <i className="fa fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                                : (<>{this.props.t("branch.message") || 'No Records Found'}</>)}

                        </tbody>
                    </Table>
                    </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Grid>
                <Grid.Row columns="1" className=" ml-2 w3-small">
                <Grid.Column width={13}>
                        <label className="font-weight-bold mt-1">{this.props.t("branch.billing_party") || "Billing Party"}</label>
                </Grid.Column>
                <Grid.Column width={3}>
                <div className="d-flex float-right">
                    <button className="w3-button w3-blue w3-hover-red w3-round w3-small" type="button" onClick={() => this.handleModelOpen()}>
                        <i className="fa fa-plus"></i> {this.props.t("branch.new") || "New"}
                    </button>
                </div>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row columns="1" className=" ml-2 w3-small">
                <Grid.Column>
                <Table hover>
                    <thead>
                        <tr className="w3-light-grey">
                            <th>{this.props.t("branch.billing_party_name") || "Billing Party Name"}</th>
                            <th>{this.props.t("branch.delete") || "Delete"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mapping_billing_branch.length > 0 ?
                            mapping_billing_branch.map((object, idx) => (
                                <tr key={idx}>
                                    <td>{object.billingPartyNamewithBranch}</td>
                                    <td>
                                        <Button onClick={this.branchBillingDelete} data-id={object.userBillingPartyBranchMapId}
                                            basic size="mini" type="button" icon variant="outline-danger">
                                            <i className="fa fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))
                            : (<>{this.props.t("branch.message") || 'No Records Found'}</>)}

                    </tbody>
                </Table>
                </Grid.Column>
                </Grid.Row>
            </Grid>
            </div>

            {/* <div className="container-fluid pad w3-white" style={{overflow: "inherient"}}>
            <Grid>
                <Grid.Row columns="1" className=" ml-2 w3-small">
                <Grid.Column width={13}>
                        <label className="font-weight-bold mt-1">{this.props.t("branch.billing_party") || "Billing Party"}</label>
                </Grid.Column>
                <Grid.Column width={2}>
                <div className="d-flex float-right">
                    <button type="button" onClick={() => this.handleModelOpen()}>
                        <i className="fa fa-plus"></i> {this.props.t("branch.new") || "New"}
                    </button>
                </div>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row columns="1" className=" ml-2 w3-small">
                <Grid.Column>
                <Table hover>
                    <thead>
                        <tr className="w3-light-grey">
                            <th>{this.props.t("branch.billing_party_name") || "Billing Party Name"}</th>
                            <th>{this.props.t("branch.delete") || "Delete"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mapping_billing_branch.length > 0 ?
                            mapping_billing_branch.map((object, idx) => (
                                <tr key={idx}>
                                    <td>{object.billingPartyNamewithBranch}</td>
                                    <td>
                                        <Button onClick={this.branchBillingDelete} data-id={object.userBillingPartyBranchMapId}
                                            basic size="mini" type="button" icon variant="outline-danger">
                                            <i className="fa fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))
                            : 'No Records Found'}

                    </tbody>
                </Table>
                </Grid.Column>
                </Grid.Row>
            </Grid>
            </div> */}

            {openViewModal && (
            <PopupModal
                //   currenOrder={replies_fetch}
                  OpenModal={openViewModal}
                  optionsBillingPartyBranch={optionsBillingPartyBranch}
                  optionsBilling={optionsBilling}
                  u_id={this.props.userInfo.u_id}
                  handleBillingPartyBranch={this.handleBillingPartyBranch}
                //   broadCastVendor={broadCastVendor}
                  reFetch={this.getBranchBillingData}
                  CloseModal={this.handleCloseModal }
                  size="mini"
                //   rebidonSubmit={() => this.bitSumbit()}
                />
                )}
            </>
        )
    }
}
export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(translate("create_user")(UserBranch))